<template>
  <div class="relative right-0 h-content-window overflow-hidden">
    <div class="w-full h-full bg-gradient-to-br from-blue-50 to-indigo-100 overflow-auto p-8 pb-28">
      <div class="max-w-4xl mx-auto flex flex-col items-center justify-center h-full text-center">
        <!-- Photo de profil -->
        <div class="mb-8">
          <img
            src="/img/profile-picture.webp"
            alt="Steven Lucarno DODDE"
            class="w-48 h-48 rounded-full object-cover shadow-2xl border-4 border-white mx-auto"
          />
        </div>

        <!-- Message de remerciement -->
        <div class="space-y-6">
          <h1 class="font-trebuchet-pixel text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {{ $t('windows.thankYou.title') }}
          </h1>
          
          <p class="font-trebuchet-pixel text-lg md:text-xl text-gray-700 leading-relaxed max-w-2xl mx-auto">
            {{ $t('windows.thankYou.message') }}
          </p>

          <div class="mt-8 pt-6 border-t border-gray-300">
            <p class="font-trebuchet-pixel text-base text-gray-600">
              {{ $t('windows.thankYou.signature') }}
            </p>
          </div>
        </div>
      </div>
      <PreviousButton current-window-id="thankYou" @open-window="$emit('open-window', $event)" @minimize-window="$emit('minimize-window', $event)" />
    </div>
  </div>
</template>

<script setup>
import PreviousButton from './PreviousButton.vue'

defineEmits(['open-window', 'minimize-window'])
</script>

<style scoped>
/* Styles supplémentaires si nécessaire */
</style>

